<script>
  import {
    VSelect
  } from 'vuetify/lib'
  export default {
    name: 'wh-select',
    extends: VSelect
  };
</script>